import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import TopMenu from "./components/TopMenu";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.min.css";

//const Header = lazy(() => import("./components/Header"));
//const TopMenu = lazy(() => import("./components/TopMenu"));
const HomeView = lazy(() => import("./views/Home"));
const SignInView = lazy(() => import("./views/account/SignIn"));
const SignUpView = lazy(() => import("./views/account/SignUp"));
const ForgotPasswordView = lazy(() => import("./views/account/ForgotPassword"));
const OrdersView = lazy(() => import("./views/account/Orders"));
const WishlistView = lazy(() => import("./views/account/Wishlist"));
const NotificationView = lazy(() => import("./views/account/Notification"));
const MyProfileView = lazy(() => import("./views/account/MyProfile"));
const ProductListView = lazy(() => import("./views/product/List"));
const ProductDetailView = lazy(() => import("./views/product/Detail"));
const Album = lazy(() => import("./views/product/My_Products/Album"));
const Nonvowenbag = lazy(() => import("./views/product/My_Products/Nonvowenbag"));
const Idcard = lazy(() => import("./views/product/My_Products/Idcard"));
const Home_Name_Plate = lazy(() => import("./views/product/My_Products/Home_Name_Plate"));
const Award_with_Star = lazy(() => import("./views/product/My_Products/Award_with_Star"));
const Classic_Award_with_Star = lazy(() => import("./views/product/My_Products/Classic_Award_with_Star"));
const Cat_Shape_Penholder = lazy(() => import("./views/product/My_Products/Cat_Shape_ Penholder"));
const Cut_Out_Photo_for_event_gift = lazy(() => import("./views/product/My_Products/Cut_Out_Photo_for_event_gift"));
const Love_Couple_tree_heart_Frame = lazy(() => import("./views/product/My_Products/Love_Couple_tree_heart_Frame"));
const Pamphlet_Mobile_Holder = lazy(() => import("./views/product/My_Products/Pamphlet_Mobile_Holder"));
const Royal_Crafted_Basket = lazy(() => import("./views/product/My_Products/Royal_Crafted_Basket"));
const Royal_Crafted_Mirror = lazy(() => import("./views/product/My_Products/Royal_Crafted_Mirror"));
const Royal_Crafted_table = lazy(() => import("./views/product/My_Products/Royal_Crafted_table"));
const Small_Car_Temple_on_mdf = lazy(() => import("./views/product/My_Products/Small_Car_Temple_on_mdf"));
const Small_Car_Temple_on_mdf_carved = lazy(() => import("./views/product/My_Products/Small_Car_Temple_on_mdf_carved"));
const Small_Temple_Sihasan_Peacock_Shaped = lazy(() => import("./views/product/My_Products/Small_Temple_Sihasan_Peacock_Shaped"));
const Small_Temple_Sihasan_Round_Shaped_with_Aum = lazy(() => import("./views/product/My_Products/Small_Temple_Sihasan_Round_Shaped_with_Aum"));
const Mug = lazy(() => import("./views/product/My_Products/Mug"));
const Vcards = lazy(() => import("./views/product/My_Products/Vcards"));
const Clocka1 = lazy(() => import("./views/product/My_Products/Clocka1"));
const Mkstand = lazy(() => import("./views/product/My_Products/Mkstand"));
const Round_small_table_stand = lazy(() => import("./views/product/My_Products/Round_small_table_stand"));
const Bill = lazy(() => import("./views/product/My_Products/Bill"));
const Tshirts = lazy(() => import("./views/product/My_Products/Tshirts"));
const Engraved_Wooden_Plank = lazy(() => import("./views/product/My_Products/Engraved_Wooden_Plank"));
const Brochure = lazy(() => import("./views/product/My_Products/Brochure"));
const Photo = lazy(() => import("./views/product/My_Products/Photo"));
const Invitation = lazy(() => import("./views/product/My_Products/Invitation"));
const Name_Keychain = lazy(() => import("./views/product/My_Products/Name_Keychain"));
const Mobile_stand_a = lazy(() => import("./views/product/My_Products/Mobile_stand_a"));
const Temple_a = lazy(() => import("./views/product/My_Products/Temple_a"));
const StarZoneView = lazy(() => import("./views/product/StarZone"));
const CartView = lazy(() => import("./views/cart/Cart"));
const CheckoutView = lazy(() => import("./views/cart/Checkout"));
const InvoiceView = lazy(() => import("./views/cart/Invoice"));
const DocumentationView = lazy(() => import("./views/Documentation"));
const NotFoundView = lazy(() => import("./views/pages/404"));
const InternalServerErrorView = lazy(() => import("./views/pages/500"));
const ContactUsView = lazy(() => import("./views/pages/ContactUs"));
const SupportView = lazy(() => import("./views/pages/Support"));
const BlogView = lazy(() => import("./views/blog/Blog"));
const BlogDetailView = lazy(() => import("./views/blog/Detail"));
const Graphic = lazy(() => import("./views/my_pages/my_graphic"));
const Construction = lazy(() => import("./views/my_pages/my_construction"));
const Gents = lazy(() => import("./views/my_pages/my_gents"));
const Printing = lazy(() => import("./views/my_pages/my_printing"));
const Social = lazy(() => import("./views/my_pages/my_social"));
const Tshirt = lazy(() => import("./views/my_pages/my_tshirt"));
const Video = lazy(() => import("./views/my_pages/my_video"));
const Web = lazy(() => import("./views/my_pages/my_web"));
const Products = lazy(() => import("./views/my_pages/my_products"));

function App() {
  return (
    <BrowserRouter>
      <React.Fragment>
        <Header />
        <TopMenu />
        <Suspense
          fallback={
            <div className="text-white text-center mt-3">Loading...</div>
          }
        >
          <Routes>
            <Route exact path="/" element={<ProductListView />} />
            <Route exact path="/account/signin" element={<SignInView />} />
            <Route exact path="/account/signup" element={<SignUpView />} />
            <Route
              exact
              path="/account/forgotpassword"
              element={<ForgotPasswordView />}
            />
            <Route exact path="/account/profile" element={<MyProfileView />} />
            <Route exact path="/account/orders" element={<OrdersView />} />
            <Route exact path="/account/wishlist" element={<WishlistView />} />
            <Route
              exact
              path="/account/notification"
              element={<NotificationView />}
            />
            <Route exact path="/category" element={<HomeView />} />
            <Route exact path="/product/detail" element={<ProductDetailView />} />
            <Route exact path="/product/Album" element={<Album />} />
            <Route exact path="/product/Tshirts" element={<Tshirts />} />
            <Route exact path="/product/Temple_a" element={<Temple_a />} />
            <Route exact path="/product/Clocka1" element={<Clocka1 />} />
            <Route exact path="/product/Home_Name_Plate" element={<Home_Name_Plate />} />
            <Route exact path="/product/Nonvowenbag" element={<Nonvowenbag />} />
            <Route exact path="/product/Engraved_Wooden_Plank" element={<Engraved_Wooden_Plank />} />
            <Route exact path="/product/Name_Keychain" element={<Name_Keychain />} />
            <Route exact path="/product/Idcard" element={<Idcard />} />
            <Route exact path="/product/Mug" element={<Mug />} />
            <Route exact path="/product/Bill" element={<Bill />} />
            <Route exact path="/product/Brochure" element={<Brochure />} />
            <Route exact path="/product/Vcards" element={<Vcards />} />
            <Route exact path="/product/Award_with_Star" element={<Award_with_Star />} />
            <Route exact path="/product/Cut_Out_Photo_for_event_gift" element={<Cut_Out_Photo_for_event_gift />} />
            <Route exact path="/product/Love_Couple_tree_heart_Frame" element={<Love_Couple_tree_heart_Frame />} />
            <Route exact path="/product/Pamphlet_Mobile_Holder" element={<Pamphlet_Mobile_Holder />} />
            <Route exact path="/product/Royal_Crafted_Basket" element={<Royal_Crafted_Basket />} />
            <Route exact path="/product/Classic_Award_with_Star" element={<Classic_Award_with_Star />} />
            <Route exact path="/product/Royal_Crafted_table" element={<Royal_Crafted_table />} />
            <Route exact path="/product/Royal_Crafted_Mirror" element={<Royal_Crafted_Mirror />} />
            <Route exact path="/product/Small_Car_Temple_on_mdf" element={<Small_Car_Temple_on_mdf />} />
            <Route exact path="/product/Small_Car_Temple_on_mdf_carved" element={<Small_Car_Temple_on_mdf_carved />} />
            <Route exact path="/product/Small_Temple_Sihasan_Peacock_Shaped" element={<Small_Temple_Sihasan_Peacock_Shaped />} />
            <Route exact path="/product/Brochure" element={<Brochure />} />
            <Route exact path="/product/Small_Temple_Sihasan_Round_Shaped_with_Aum" element={<Small_Temple_Sihasan_Round_Shaped_with_Aum />} />
            <Route exact path="/product/Round_small_table_stand" element={<Round_small_table_stand/>} />
            <Route exact path="/product/Cat_Shape_Penholder" element={<Cat_Shape_Penholder />} />
            <Route exact path="/product/Mkstand" element={<Mkstand />} />
            <Route exact path="/product/Mobile_stand_a" element={<Mobile_stand_a />} />
            <Route exact path="/product/Engraved_Wooden_Plank" element={<Engraved_Wooden_Plank />} />
            <Route exact path="/product/Photo" element={<Photo />} />
            <Route exact path="/star/zone" element={<StarZoneView />} />
            <Route exact path="/cart" element={<CartView />} />
            <Route exact path="/checkout" element={<CheckoutView />} />
            <Route exact path="/invoice" element={<InvoiceView />} />
            <Route exact path="/documentation" element={<DocumentationView />} />
            <Route exact path="/contact-us" element={<ContactUsView />} />
            <Route exact path="/support" element={<SupportView />} />
            <Route exact path="/blog" element={<BlogView />} />
            <Route exact path="/blog/detail" element={<BlogDetailView />} />
            <Route exact path="/500" element={<InternalServerErrorView />} />
            <Route exact path="/graphic_designing" element={<Graphic />} />
            <Route exact path="/construction" element={<Construction />} />
            <Route exact path="/gents" element={<Gents />} />
            <Route exact path="/printing" element={<Printing />} />
            <Route exact path="/social" element={<Social />} />
            <Route exact path="/tshirt" element={<Tshirt />} />
            <Route exact path="/video" element={<Video />} />
            <Route exact path="/web" element={<Web />} />
            <Route exact path="/products" element={<Products />} />
            <Route path="*" element={<NotFoundView />} />
          </Routes>
        </Suspense>
        <Footer />
      </React.Fragment>
    </BrowserRouter>
  );
}

export default App;
